/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-wide[_ngcontent-%COMP%]{max-width:1640px;margin-left:auto;margin-right:auto;padding-left:20px;padding-right:20px}[_nghost-%COMP%]{display:block;z-index:1}[_nghost-%COMP%]   [_ngcontent-%COMP%]:not(app-panels){padding-left:20px;padding-right:20px}@media (min-width:1024px){.container-wide[_ngcontent-%COMP%]{padding-left:30px;padding-right:30px}[_nghost-%COMP%]   [_ngcontent-%COMP%]:not(app-panels){max-width:1140px;margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}}"];
export { styles as styles };
